import BaseService from "./BaseService";
import { toast, Notification } from "components/ui";

const ApiService = {
  fetchData(param) {
    return new Promise((resolve, reject) => {
      BaseService(param)
        .then((response) => {
          resolve(response);

          if (response?.data?.message || response?.data?.response) {
            toast.push(
              <Notification
                title={"Successfully Done"}
                type="success"
                duration={2500}
              >
                {response.data.message || response.data.response}
              </Notification>,
              {
                placement: "top-center",
              }
            );
          } else if (typeof response?.data === "string" && response.data.length > 0) {
            // Do not showtoast here automatically unless it's a known pattern, 
            // but the user's prompt suggests they want to show exactly that message on frontend.
            // Actually, we'll just resolve the response. The caller can handle it, or we toast it here.
            // Let's just resolve for now.
          }

        })
        .catch((errors) => {
          const errorResponse = errors.response?.data;

          if (errorResponse) {
            let errorTitle = "Error";
            let errorMessages = "An unexpected error occurred.";

            if (typeof errorResponse === "string") {
              errorMessages = errorResponse;
            } else {
              errorTitle = errorResponse.title || "Validation Error";
              const validationErrors = errorResponse.errors;
              errorMessages = validationErrors
                ? Object.entries(validationErrors)
                  .map(([_, messages]) => messages.join(", ")) 
                  .join(" | ") 
                : "An unexpected error occurred.";
            }

            toast.push(
              <Notification title={errorTitle} type="danger" duration={4000}>
                {errorMessages}
              </Notification>,
              {
                placement: "top-center",
              }
            );
          } else {
            // Default error message for unexpected issues
            toast.push(
              <Notification title={"Error"} type="danger" duration={4000}>
                {"An unexpected error occurred."}
              </Notification>,
              {
                placement: "top-center",
              }
            );
          }

          reject(
            typeof errorResponse === "string"
              ? errorResponse
              : errorResponse?.title || "An unexpected error occurred."
          );
        });
    });
  },
};

export default ApiService;


